import { prefixObjectValues } from '../../utils';
const form = {
  primaryFacilitySelect: 'primary-facility-select',
  statesSelect: 'states-select',
  facilitiesSelect: 'facilities-select',
  addBtn: 'add-btn',
  hydrationRetryBtn: 'hydration-retry-btn',
};
export default prefixObjectValues(form, 'facility-form');
